import React from 'react'
import { NavLink as ReactRouterNavLink } from 'react-router-dom'

export default function NavLink (props) {
  // return <a href={props.to} {...props} />
  return <ReactRouterNavLink {...props} />
}
